export enum IncidentAction {
	Continue = 1,
	Stop = 2,
	StopAndApplySanction = 3,
}

/**
 * Mirrors BE `IncidentService.EnsureSanctionSubjectIdentified` — a sanction is written against the control
 * object's subject, so an order whose control object holds no subject has nothing to sanction.
 */
export const isIncidentActionAllowed = (action: IncidentAction, subjectIdentified: boolean): boolean =>
	subjectIdentified || action !== IncidentAction.StopAndApplySanction;
